module.exports = __webpack_public_path__ + "media/microsite.1c2edd86.mp4";